module.exports = __webpack_public_path__ + "static/landingbuilder-3-5aafdf58d5f22a335bb4c4444e41af94.png";